import { Component, OnInit } from '@angular/core';

import { MatDialogRef } from '@angular/material/dialog';
import { SsModule } from '@app/models';
import { TableService } from '@app/services';

@Component({
    selector: 'duplication-merger-dialog',
    templateUrl: './duplication-merger-dialog.component.html',
    styleUrls: ['./duplication-merger-dialog.component.scss'],
    standalone: false
})
export class DuplicationMergerDialogComponent implements OnInit {
  modulePassedIn: SsModule = null;
  recordsPassedIn: any[] = []; // If we just want to pass records in without a table.

  retrievingRecords: boolean = true;
  chosenRecords = null;
  fields = null;
  primaryRecord = null;
  primaryCopy = null;
  masterRecordIndex = 0;
  mergedEmail: boolean = false;

  fieldToIndexMapping = {};
  pickedFields: { [fieldName: string]: number } = {}; // Tracks which dup index a field was picked from.
  differingFields: { [fieldName: string]: boolean } = {}; // True if field values differ across records.

  constructor(
    public dialogRef: MatDialogRef<DuplicationMergerDialogComponent>,
    private _tableService: TableService
  ) { }

  ngOnInit() {
    this.retrievingRecords = false;

    // If we choose to pass records use them. Otherwise, use default way.
    if (this.recordsPassedIn?.length) this.chosenRecords = this.recordsPassedIn;
    else this.chosenRecords = this._tableService?.selectedRows?.selected?.filter(_i => _i) ?? [];

    if (this.chosenRecords && this.chosenRecords.length) {
      this.primaryRecord = {...this.chosenRecords[0]}; // default is first selected value
    }

    this.fields = this.modulePassedIn.fields;

    this.setPrimaryRecord(0);
    this.computeDifferingFields();
  }


  /** Computes which fields have different values across all records. */
  computeDifferingFields() {
    if (!this.fields?.length || !this.chosenRecords?.length) return;

    const allRecords = [this.primaryRecord, ...this.chosenRecords].filter(Boolean);

    for (const field of this.fields) {
      const fn = field.fieldName;
      const values = allRecords.map(r => {
        const val = r[fn];
        if (val == null || val === '') return null;
        if (typeof val === 'object') return JSON.stringify(val);
        return String(val);
      });

      const unique = new Set(values);
      this.differingFields[fn] = unique.size > 1;
    }
  }


  removeRecord(_recordIndex) {
    this.chosenRecords.splice(_recordIndex, 1);
  }


  setPrimaryRecord(_recordIndex) {
    this.primaryRecord = null;
    this.fields.forEach(_f => this.fieldToIndexMapping[_f.fieldName] = _recordIndex);
    this.pickedFields = {}; // Reset picks when switching primary.

    setTimeout(() => {
      this.primaryRecord = {...this.chosenRecords[_recordIndex]};
      this.masterRecordIndex = _recordIndex;
      this.computeDifferingFields();
    }, 500);
  }


  setPrimaryFromField(_chosenRecordIndex, _fieldName) {
    if (_fieldName === 'email') {
      this.mergedEmail = true;
      _fieldName = 'email_addresses';

      const emailAddressesToMerge = this.chosenRecords[_chosenRecordIndex][_fieldName];

      if (this.primaryRecord['email_addresses'] && this.primaryRecord['email_addresses'].length) {
        // add the new one
        const existingEmailAddresses = [...this.primaryRecord['email_addresses']];
        emailAddressesToMerge.forEach(_ea => existingEmailAddresses.push(_ea));

        this.primaryRecord['email_addresses'] = existingEmailAddresses;
      } else {
        this.primaryRecord['email_addresses'] = emailAddressesToMerge;
      }
    } else {
      this.primaryRecord[_fieldName] = this.chosenRecords[_chosenRecordIndex][_fieldName];
    }

    this.fieldToIndexMapping[_fieldName] = _chosenRecordIndex;
    this.pickedFields[_fieldName] = _chosenRecordIndex;

    this.primaryCopy = {...this.primaryRecord};
    this.primaryRecord = null;

    setTimeout(() => this.primaryRecord = {...this.primaryCopy}, 100);
  }


  saveMerge() {
    this.closeDialog(true);
  }


  cancel() {
    this.closeDialog(false);
  }


  closeDialog(_mergeConfirmed) {
    let mergeRequest = null;

    if (_mergeConfirmed && this.primaryRecord._id) {
      const primaryIndex = this.chosenRecords.findIndex(_r => _r && _r._id === this.primaryRecord._id);
      this.chosenRecords.splice(primaryIndex, 1).map(_r => _r._id);

      mergeRequest = {
        mergedEmail: this.mergedEmail,
        primaryRecord: this.primaryRecord,
        recordsToDelete: this.chosenRecords
      };
    } else {
      console.log('Primary Record does not have an id? ', this.primaryRecord);
    }

    return this.dialogRef.close(mergeRequest);
  }

}
